import React, { createContext } from 'react';
import { Filters } from 'types/Search';

type SearchValue = {
  filters: Filters;
}

const SearchStateContext = createContext<SearchValue>({
  filters: {} as Filters
});

type Props = {
  children: React.ReactNode;
  filters: Filters;
};

const SearchStateProvider = ({ children, filters }: Props) => {
  return (
    <SearchStateContext.Provider value={{ filters }}>
      {children}
    </SearchStateContext.Provider>
  );
};

export { SearchStateProvider, SearchStateContext};
